import { Icon } from './Icon';

/**
 * Paginazione server-side riusabile per le liste (CRM, progetti, fatture, ecc.).
 * Mostra il range "X–Y di TOTALE" + navigazione Prec/Succ con "pagina P di N".
 * Si nasconde se non c'è nulla da paginare (≤1 pagina e ≤ pageSize record).
 */
export function Pagination({
  page,
  pageSize,
  total,
  totalPages,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  onPage: (page: number) => void;
}) {
  // Nascondiamo solo se non c'è proprio nulla (l'empty-state pensa al resto).
  // Altrimenti mostriamo sempre il conteggio + Prec/Succ (disattivati se c'è 1 sola pagina),
  // così la paginazione è visibile e coerente in ogni lista.
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const tp = Math.max(1, totalPages);
  return (
    <div className="flex items-center justify-between gap-3 mt-4 px-1 text-[13px]">
      <span className="mute">{total === 0 ? 'Nessun risultato' : <><span className="mono">{from}–{to}</span> di <span className="mono">{total}</span></>}</span>
      <div className="flex items-center gap-2">
        <button className="btn btn-sm" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Pagina precedente">
          <Icon name="arrowLeft" size={12} /> Prec
        </button>
        <span className="mute mono px-1">Pagina {page} di {tp}</span>
        <button className="btn btn-sm" disabled={page >= tp} onClick={() => onPage(page + 1)} aria-label="Pagina successiva">
          Succ <Icon name="arrowRight" size={12} />
        </button>
      </div>
    </div>
  );
}
